import { FunctionComponent } from 'react'
import styles from './parentNotification.module.scss'
import { TableCell, TableRow } from '@mui/material'
import Checkbox from '@/components/_custom/Checkbox/Checkbox'

interface TableRowPreferencesProps {
    legend: string
    mailNotification?: boolean
    pushNotification?: boolean
    setNotifMail?: (value: boolean) => void
    setNotifPush?: (value: boolean) => void
    setParentNotifsWasUpdated: (value: boolean) => void
}

const TableRowPreferences: FunctionComponent<TableRowPreferencesProps> = ({
    legend,
    mailNotification,
    pushNotification,
    setNotifMail,
    setNotifPush,
    setParentNotifsWasUpdated
}: TableRowPreferencesProps) => {
    function handleMail(): void {
        if (setNotifMail !== undefined) setNotifMail(!mailNotification)
        setParentNotifsWasUpdated(true)
    }

    function handlePush(): void {
        if (setNotifPush !== undefined) setNotifPush(!pushNotification)
        setParentNotifsWasUpdated(true)
    }

    return (
        <TableRow>
            <TableCell sx={{ width: '60%' }}>{legend}</TableCell>
            <TableCell sx={{ width: '20%' }} align={'center'}>
                {mailNotification != undefined && (
                    <Checkbox
                        checked={mailNotification.valueOf()}
                        color={'primary'}
                        onChange={handleMail}
                        required
                        parent
                        className={styles.Checkbox}
                    />
                )}
            </TableCell>
            <TableCell sx={{ width: '20%' }} align={'center'}>
                {pushNotification != undefined && (
                    <Checkbox
                        checked={pushNotification.valueOf()}
                        color={'primary'}
                        onChange={handlePush}
                        required
                        parent
                        className={styles.Checkbox}
                    />
                )}
            </TableCell>
        </TableRow>
    )
}

export default TableRowPreferences
